import { useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { PW_AUTH_TOKEN_KEY } from "../../../api/client"
import { TokenEventDetail } from "../../../lib/utils/auth-token"
import getAuthRoute from ".././utils/getAuthRoute"

// Checks for if two token events occur where the source's are different
// but the token values are the same. This indicates the user authenticated
// via some "external" method (like a bookmarklet script, for example).
// We conveniently handle routing when this occurs since otherwise the user
// will remain at the current route.
const useExternalAuthNavigate = () => {
  const navigate = useNavigate()
  const tokenEventDataRef = useRef<TokenEventDetail>()

  useEffect(() => {
    const handler = (e: CustomEvent<TokenEventDetail>) => {
      if (tokenEventDataRef.current) {
        if (
          tokenEventDataRef.current.source !== e.detail.source &&
          tokenEventDataRef.current.token === e.detail.token
        ) {
          navigate(getAuthRoute("/"))
        }
      } else {
        tokenEventDataRef.current = e.detail
      }
    }

    window.addEventListener(PW_AUTH_TOKEN_KEY, handler)
    return () => {
      window.removeEventListener(PW_AUTH_TOKEN_KEY, handler)
    }
  }, [])
}

export default useExternalAuthNavigate
